// Runtime-detected backend base URL.
//
// Why this exists: in production the frontend is served from
// `tourismintel.ai` and the platform proxies `/api/*` to the FastAPI backend
// on the SAME origin — that's the whole point of moving to a same-site
// setup (no Safari ITP / Firefox ETP cross-site cookie stripping).
//
// We CANNOT bake `REACT_APP_BACKEND_URL=https://tourismintel.ai` into the
// build because that would break the preview environment (which is served
// from `pixel-news-travel.preview.emergentagent.com` and must keep calling
// its own backend, not the production one).
//
// Solution: pick the backend at runtime based on the browser's location.
// In production the URL collapses to same-origin; in preview/dev it falls
// back to the env var that's baked at build time (which still points to
// the preview's same-origin URL, also fine).
//
// Hosts considered "production":
//   - tourismintel.ai
//   - www.tourismintel.ai
// Anything else uses the build-time env var.

const PROD_HOSTS = new Set(["tourismintel.ai", "www.tourismintel.ai"]);

function detectBackendUrl() {
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname;
    if (PROD_HOSTS.has(host)) {
      // Same-origin: use whatever scheme+host the page is loaded from.
      // The platform proxies /api/* to FastAPI on this origin.
      return `${window.location.protocol}//${window.location.host}`;
    }
  }
  // Preview / dev: keep the existing env-var-driven behaviour.
  return process.env.REACT_APP_BACKEND_URL || "";
}

export const BACKEND_URL = detectBackendUrl();
export const API = `${BACKEND_URL}/api`;
